import { Component, OnDestroy } from "@angular/core";
import { IHeaderAngularComp } from "@ag-grid-community/angular";
import { GridApi, IHeaderParams } from "@ag-grid-community/core";
import { ShipyardService } from "../../modules/shipyard/shipyard.service";
import { Subject } from "rxjs";

@Component({
  selector: "app-grid-checkbox-header-renderer",
  templateUrl: "./grid-checkbox-header-renderer.component.html",
  styleUrls: ["./grid-checkbox-header-renderer.component.scss"],
})
export class GridCheckboxHeaderRendererComponent implements IHeaderAngularComp,OnDestroy {
  public params: any;
  gridApi: GridApi;
  isSelectAll: boolean = false;
  private destroy$ = new Subject<void>();
  constructor(private shipyardService: ShipyardService) {}

  agInit(params: IHeaderParams): void {
    this.params = params;
    this.gridApi = params.api;
  }

  refresh(params: IHeaderParams): boolean {
    return false;
  }

  onSelectAll() {
    if (this.isSelectAll) {
      // node.setSelected(true);
    } else {
      this.gridApi?.deselectAll();
      this.shipyardService.shipmentTypeToAddToShipment$.next(undefined);
      if (this.shipyardService.skusToAddToShipment.length) {
        this.shipyardService.skusToAddToShipment = [];
      }
    }
    // this.gridApi.forEachNode((node) => {
    //
    // });
  }

  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
